module.exports = __webpack_public_path__ + "media/bootstrap-icons/bootstrap-fill-68ad837c.svg";